/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_TAX_TYPE,
  SET_TAX_RATE,
  SET_LIAB_ITC,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  taxTypeData: [],
  taxRateData: [],
  liabITCData: []
};

/* eslint-disable default-case, no-param-reassign */
const RCMLiabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_TAX_TYPE:
      return {
        ...state,
        taxTypeData: action.taxTypeData
      };
    case SET_TAX_RATE:
      return {
        ...state,
        taxRateData: action.taxRateData
      };
    case SET_LIAB_ITC:
      return {
        ...state,
        liabITCData: action.liabITCData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        taxTypeData: [],
        taxRateData: [],
        liabITCData: []
      };
    default:
      return state;
  }
};

export default RCMLiabilityReducer;
